import { render, staticRenderFns } from "./DownlineBody.vue?vue&type=template&id=7f68dc85&scoped=true&"
import script from "./DownlineBody.vue?vue&type=script&lang=ts&"
export * from "./DownlineBody.vue?vue&type=script&lang=ts&"
import style0 from "./DownlineBody.vue?vue&type=style&index=0&id=7f68dc85&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f68dc85",
  null
  
)

export default component.exports